import { useRouter } from 'next/navigation'
import { createContext, useContext, useRef, useState, useMemo } from 'react'
import { replaceState, getApiParam } from './lib'

const ListingConfig = createContext(null)

export function useListing() {
  return useContext(ListingConfig)
}

export function ListingProvider({
  init = {},
  children
}) {
  const router = useRouter()
  
  // 保存mapbox实例
  const mapbox = useRef()

  // 保存地图初始化数据(比如经纬度)
  const [initial, setInitial] = useState()

  // 地图是否初始化完成，则开始加载列表数据
  const [ready, setReady] = useState(false)

  // 保存学校数据
  const [school, setSchool] = useState()

  // 保存街道数据
  const [street, setStreet] = useState()

  // 鼠标hover时保存的数据
  const [hoveredProperty, setHoveredProperty] = useState()

  // 显示AI面板
  const [aiPanelSize, setAIPanelSize] = useState({ width: 400, expand: false })

  const [query, setQuery] = useState(init.query)
  const [searchParam, setSearchParam] = useState(init.searchParam)
  const [apiParam, setApiParam] = useState(init.apiParam)
  const [type, setType] = useState(init.type)
  const [headline, setHeadline] = useState(init.headline)

  const config = useMemo(() => ({
    query,
    type,
    searchParam,
    mapbox,
    initial,
    school,
    street,
    ready,
    router,
    hoveredProperty,
    headline,
    aiPanelSize,
    setHoveredProperty,
    setSchool,
    setStreet,
    setReady,
    setInitial,
    replaceState,
    setQuery,
    setSearchParam,
    setApiParam,
    setType,
    setHeadline,
    setAIPanelSize,
    baseApiParam: apiParam,
    apiParam: getApiParam(query, apiParam),
  }), [
    query, type, searchParam, initial, apiParam, hoveredProperty, headline,
    school, street, ready, router, aiPanelSize,
  ])
  
  return (
    <ListingConfig.Provider value={config}>
      {children}
    </ListingConfig.Provider>
  )
}
